    import React,{useState,useEffect} from 'react';
    import PropTypes from 'prop-types';

    const LiveFunction=({channelId, videoId, width, height, autoplay, mute })=> {
        //autoplay setting
        autoplay=true;
           
        const [isMobile, setIsMobile] = useState(false);
    
        const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        });          

        //send window size
        useEffect(() => {
            const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
            };

            handleResize(); // Initial check
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        // Calculate responsive dimensions
        const getDimensions = () => {
            if (isMobile) {
            // For mobile, use full width and calculate height based on 16:9 aspect ratio
            const mobileWidth = Math.min(windowSize.width - 20, 600); // Max 600px with some padding
            return {
                width: mobileWidth,
                height: mobileWidth * (9 / 16),
            };
            }
            // For desktop, use provided dimensions or defaults
            return {
                width: width || 750,
                height: height || 500,
            };
        };

        //set dimensions
        const dimensions = getDimensions();
    
        //embed uri
        const embedUrl = videoId 
            ? `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay ? 1 : 0}&mute=${mute ? 1 : 0}&rel=0`
            : `https://www.youtube.com/embed/live_stream?channel=${channelId}&autoplay=${autoplay ? 1 : 0}&mute=${mute ? 1 : 0}&rel=0`;


        return (
        /*** Display youtube Frame */
        <div className="youtube-live-container" style={{ margin: '2rem auto', maxWidth: '100%',padding:'20px' }}>
            <iframe
                width={dimensions.width}
                height={dimensions.height}
                src={embedUrl}
                title="比賽直播"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ display: 'block', margin: '0 auto' }}
            ></iframe>
        </div>
        );

    };

    //youtube setting input
    LiveFunction.propTypes = {
    channelId: PropTypes.string, // YouTube channel ID (required if no videoId)
    videoId: PropTypes.string,   // Specific live video ID (optional)
    width: PropTypes.number,     // Custom width (desktop)
    height: PropTypes.number,    // Custom height (desktop)
    autoplay: PropTypes.bool,    // Autoplay the stream
    mute: PropTypes.bool,       // Start muted
    };

    LiveFunction.defaultProps = {
    autoplay: true,
    mute: true, // Recommended to start muted for autoplay
    };

    export default LiveFunction;

